export class QrCode {
  t: string;
  h: string;
  mc: string;
  tc: string;
  mn: string;

    constructor(data) {
      this.t = data.t;
      this.h = data.h;
      this.tc = data.tc;
      this.mc = data.mc;
      this.mn = data.mn;
    }

    getObj() {
      return {
        t: this.t,
        h: this.h,
        tc: this.tc,
        mc: this.mc,
        mn: this.mn,
      }
    }
}
